import { applicationContainer } from '@/bootstrap/applicationServiceProvider';
import { AUTHENTICATION_SERVICE } from '@/bootstrap/ServiceProviders';
import { BOOKINGKIT_ROLES } from '@/constants/roles';

const INTERNAL_ROLES = [
    BOOKINGKIT_ROLES.sales,
    BOOKINGKIT_ROLES.service,
    BOOKINGKIT_ROLES.admin,
    BOOKINGKIT_ROLES.superAdmin,
] as const;

export const useAuthenticationService = () => {
    const service = applicationContainer.get<AuthenticationServiceInterface>(AUTHENTICATION_SERVICE);
    const isInternalUser = (): boolean => INTERNAL_ROLES.some((role) => service.hasRole(role));
    return {
        logout: service.logout,
        hasRole: service.hasRole,
        getUser: service.getUser,
        isInternalUser,
    };

};

export default useAuthenticationService();
